module.exports={"Star Rating":"Évaluation","# star(s)":"{currentRating, plural, =1{# étoile} other{# étoiles}}"};